import { myAxios } from "../../utils/common";

export interface MyReferral {
  id: number;
  referred_name: string;
  status: "pending" | "enrolled" | "rewarded" | "rejected";
  reward_amount: number;
  created_at: string;
  invite_sent_at: string | null;
  application_linked: boolean;
}

export async function getReferralConfig(): Promise<{ reward_amount: number }> {
  const res = await myAxios.get("/referrals/config");
  return res.data;
}

export async function getMyReferrals(): Promise<MyReferral[]> {
  const res = await myAxios.get("/referrals/mine");
  return res.data;
}

export async function createReferral(payload: {
  name: string;
  email: string;
  phone?: string;
  note?: string;
}): Promise<Pick<MyReferral, "id" | "status" | "reward_amount">> {
  const res = await myAxios.post("/referrals", payload);
  return res.data;
}
